import QuotesCarousel from './quotes-carousel';

export default QuotesCarousel;
